let box21Api = null;

export function setBox21Api(api) {
  box21Api = api;
}

export function getBox21Api() {
  return box21Api;
}
